import styled from 'styled-components';

export const StyledFeed = styled.main`
  .feed__container {
    padding: 20px;
    .post {
      margin-top: 30px;
    }
  }
`;
